const TemplateNevis = (element) => {
  const elementUpper = document.getElementById("nevis-content-upper");
  const elementContact = document.getElementById("nevis-content-contact");
  
  const setBorderPositions = () => {
    const border0 = document.getElementById("nevis-border-0");
    const border1 = document.getElementById("nevis-border-1");
    const border2 = document.getElementById("nevis-border-2");

    let horizontalPosition1, horizontalPosition2;

    if (elementUpper && border0) {
      horizontalPosition1 = elementUpper.getBoundingClientRect().bottom;
      border0.style.top = `${horizontalPosition1}px`;
    }

    if (elementContact) {
      horizontalPosition2 = elementContact.getBoundingClientRect().top + 40;

      if (border1) {
        border1.style.height = `${horizontalPosition2 - horizontalPosition1}px`;
        border1.style.top = `${horizontalPosition1}px`;
        border1.style.left = `${border0.offsetWidth}px`;
      }

      if (border2) {
        border2.style.top = `${horizontalPosition2}px`;
      }
    }
  }

  const addResizeListeners = () => {
    window.addEventListener("resize", setBorderPositions);
  }

  const main = () => {
    addResizeListeners();
    setBorderPositions();
  }

  main();
};

export default TemplateNevis;
